/** 
*@author: satyamurthy.a
*@Description : 
**/
import './index.css';
import axios from 'axios';
import { connect } from 'react-redux';
import {Tree} from 'antd';
import React, { useEffect, useState, useRef } from 'react';
import { adapter } from '../utility/adapter';
import { getMobileTypeListData } from './ApiCalls';
import { API_MENU } from '../../../../commons/api';
import localStorage from '../../../../utils/localStorage';
import { DrawerFooter } from '../../../../commons/styles/layout';
import {
  Drawer,
  Button,
  Input,
  Select,
  message,
  Upload,
  Space,
  Form,
  Popconfirm,
  Tooltip,
  Radio
} from 'antd';
import {
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
  UploadOutlined,
} from '@ant-design/icons';

let accessToken = localStorage.get('accessToken');
const { Option } = Select;

const MenuBuilder = (props) => {
  const [treeData, setTreeData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [editObj, setEditObj] = useState({});
  const [menuType, setMenuType] = useState('Web');
  const [mobileTypeList, setMobileTypeList] = useState([]);
  const [unstructuredDataSource, setUnstructuredDataSource] = useState([]); 
  // const [searchText, setSearchText] = useState('');
  // const [searchInput, setSearchInput] = useState(null);
  const menuRef = useRef();

  useEffect(() => {
    getMenuListData(menuType);
    getMobileModules();
  }, []);

  const getMobileModules = async () => {
    let mobileTypeList = await getMobileTypeListData();
    setMobileTypeList(mobileTypeList);
  };

  const getMenuById = async () => {
    let response = await getMenuByType('Structured', menuType);
    if (response && response[0]) {
      setTreeData( adapter(response[0])); // Expand all by default
      setEditObj(response[0]);
    }
    let unstructuredData = await getMenuByType('UnStructured', menuType);
    setUnstructuredDataSource(unstructuredData);
  };


  const getMenuByType = (Type, menuType) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    let authMenuObject = {
      method: 'GET',
      url: `${API_MENU.Get}?SiteId=${siteId}&Type=${Type}&menuType=${menuType}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(authMenuObject)
      .then((response) => {
        return response.data;
      })
      .catch(function () { });
  };

  const saveMenu = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    menuRef.current.validateFields()
      .then(async (values) => {
        let payload = {
          method: 'POST',
          url: `${API_MENU.CREATE}?SiteId=${siteId}`,
          headers: {
            Authorization: `Bearer ${accessToken}`
          },
          data: {
            name: values.name,
            path: values.path,
            fullName: values.fullName,
            mobileType: values.mobileType,
            type: values.type,
            parentId: editObj.parentId,
            SiteId: siteId,
            menuType: menuType
          }
        };

        axios(payload)
          .then((response) => {
            message.success(response.data.message);
            getMenuById();
            setVisible(false);
            if (menuRef.current) {
              menuRef.current.resetFields();
            }
          })
          .catch(function (error) {
            console.log(error);
            return [];
          });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const updateMenu = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    menuRef.current.validateFields()
      .then(async (values) => {
        let payload = {
          method: 'PATCH',
          url: `${API_MENU.Update}?SiteId=${siteId}`,
          headers: {
            Authorization: `Bearer ${accessToken}`
          },
          data: {
            name: values.name,
            path: values.path,
            fullName: values.fullName,
            mobileType: values.mobileType,
            type: values.type,
            parentId: editObj.parentId,
            Id: editObj.Id,
            SiteId: siteId,
            menuType: menuType
          }
        };

        axios(payload)
          .then((response) => {
            message.success(response.data.message);
            getMenuById();
            if (menuRef.current) {
              menuRef.current.resetFields();
            }
            setVisible(false);
          })
          .catch(function (error) {
            console.log(error);
            return [];
          });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const deleteMenuItem = (Id) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let payload = {
      method: 'DELETE',
      url: `${API_MENU.DELETE}?SiteId=${siteId}&Id=${Id}&menuType=${menuType}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };

    axios(payload)
      .then((response) => {
        message.success(response.data.message);
        getMenuById();
        if (menuRef.current) {
          menuRef.current.resetFields();
        }
      })
      .catch(function (error) {
        console.log(error);
        return [];
      });
  };

  const UploadMenu = (e) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let payload = {
      method: 'POST',
      url: `${API_MENU.BULKUPLOAD}?SiteId=${siteId}&menuType=${menuType}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: e
    };

    axios(payload)
      .then((response) => {
        message.success(response.data.message);
        getMenuById();
        if (menuRef.current) {
          menuRef.current.resetFields();
        }
      })
      .catch(function (error) {
        console.log(error);
        return [];
      });
  };

  const getMenuListData = async () => {
    getMenuById();
  };

  const editMenuItem = (obj) => {
    let editObj = obj.maniObj;
    if (menuRef.current) {
      menuRef.current.setFieldsValue(editObj);
    }
    setVisible(true);
    setEditObj(editObj);
  };

  const onClose = () => {
    if (menuRef.current) {
      menuRef.current.resetFields();
    }
    setVisible(false);
    setEditObj({});
  };

  const OnAddModule = (data) => {
    let parentId = data && data && data.maniObj && data.maniObj.key ? data.maniObj.key : 0;
    if (menuRef.current) {
      menuRef.current.resetFields();
    }
    setVisible(true);
    setEditObj({ parentId });
  };

  const translation = (keyword) => {
    let translationCache = props.translationCache;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

 const onMenuTypeChange = async (menuType) => {
    let response = await getMenuByType('Structured', menuType);
    let unstructuredData = await getMenuByType('UnStructured', menuType);
    if (response && response[0]) {
      setTreeData(adapter(response[0])
      ); 
      setEditObj(response[0]);
      setMenuType(menuType);
      setUnstructuredDataSource(unstructuredData);
    }
  };
 const handleMoveNode = async (node, nextParentNode) => {
    const siteId = localStorage.get('currentSite'); 
    let data = {
        ...node.maniObj,
        parentId: nextParentNode?.maniObj?.key || null,
        menuType: menuType
    };
    delete data.children;
    let payloadData = {
        method: 'PATCH',
        url: `${API_MENU.Update}?SiteId=${siteId}`,
        headers: {
            Authorization: `Bearer ${accessToken}`
        },
        data
    };
    try {
        const response = await axios(payloadData);
        message.success(response.data.message);
        getMenuListData();
    } catch (error) {
        console.log(error);
    }
};
const onDrop = (info) => {
    const { node, dragNode } = info;
    handleMoveNode(dragNode, node);
};
  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Radio.Group
          onChange={(e) => {
            onMenuTypeChange(e.target.value);
          }}
          value={menuType}
          options={[
            {
              label: 'Web',
              value: 'Web',
            },
            {
              label: 'Mobile',
              value: 'Mobile',
            }
          ]}
        />
        <div>
          <Space>
            <Upload
              name="file"
              accept="application/json"
              headers={{
                Authorization: `Bearer ${accessToken}`
              }}
              beforeUpload={(file) => {
                const reader = new FileReader();
                reader.onload = (e) => {
                  UploadMenu(JSON.parse(e.target.result));
                };
                reader.readAsText(file);
                return false;
              }}
            >
              <Button type='primary'>
                <UploadOutlined /> {translation('Upload')}
              </Button>
            </Upload>

            <div>
              <Button
                type="primary"
                href={`data:text/json;charset=utf-8,${encodeURIComponent(
                  JSON.stringify(unstructuredDataSource)
                )}`}
                download="menuConfiguration.json"
              >
                <DownloadOutlined /> {translation(`Download`)}
              </Button>
            </div>
          </Space>
        </div>
      </div>

      <div className="Scroll" style={{ padding: '20px 0px', minHeight: '80vh', color: "#686868" }}>
        <Tree
      treeData={treeData}
      draggable
     
      showLine={true}
      onDrop={onDrop}
      onChange={(newTreeData) => {
        setTreeData(newTreeData);
      }}
      isVirtualized={false}
      slideRegionSize={0}
      rowHeight={100}
      titleRender={(node,index) => {
        
        if (node.name === 'Modules' || node.name === 'Configuration') {
          return node.title; 
        } else {
          return (
            <span>
              {node.title}
              <PlusOutlined
              key={index}
                style={{ margin: '7px' }}
                onClick={() => OnAddModule(node)}
              />
              <EditOutlined
              key={index}
                style={{ margin: '7px' }}
                onClick={() => editMenuItem(node)}
              />
              <Popconfirm
                 key="delete"
                title={translation('Are you sure, do you want to delete?')}
                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                onConfirm={() => {
                  deleteMenuItem(node.maniObj.Id);
                }}
                okText={translation('Yes')}
                cancelText={translation('No')}
              >
                <Tooltip title={translation('Delete')}>
                  <DeleteOutlined key={index} style={{ margin: '7px' }} />
                </Tooltip>
              </Popconfirm>
            </span>
          );
        }
      }}
    />

    
      </div>

      <Drawer
        title={
          editObj && editObj.Id
            ? translation('Update MenuItem')
            : translation('Create MenuItem')
        }
        width={600}
        closable
        onClose={onClose}
        open={visible}
        bodyStyle={{ paddingBottom: 80 }}
      >
        <Form
          layout="vertical"
          ref={menuRef}
          name="user_form"
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 14 }}
          initialValues={editObj || {}}
          onFinishFailed={() => message.error('Please enter required fields')}
        >
          <Form.Item
            label={translation('Type')}
            name="type"
            rules={[
              {
                required: true,
                message: translation('Select Type')
              }
            ]}
          >
            <Select value={editObj.type} placeholder={translation('Select Type')}>
              {treeData &&
                Array.isArray(treeData) &&
                treeData.map((item) => (
                  <Option key={item.key} value={item.key}>
                    {item.key}
                  </Option>
                ))}
            </Select>
          </Form.Item>
          {menuType === 'Mobile' ? (
            <Form.Item
              label={translation('ModuleType')}
              name="mobileType"
              rules={[
                {
                  required: true,
                  message: translation('Select Module Type')
                }
              ]}
            >
              <Select value={editObj.mobileType} placeholder={translation('Select Type')}>
                {mobileTypeList &&
                  Array.isArray(mobileTypeList) &&
                  mobileTypeList.map((item) => (
                    <Option key={item.Value} value={item.Key}>
                      {item.key}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          ) : null}

          <Form.Item
            label={translation('Name')}
            name="name"
            rules={[
              {
                required: true,
                message: translation('Select Module name')
              }
            ]}
          >
            <Input placeholder={translation('Select Module name')} />
          </Form.Item>
          <Form.Item
            label={translation('Full Name')}
            name="fullName"
            rules={[
              {
                required: false,
                message: translation('Select Full name')
              }
            ]}
          >
            <Input placeholder={translation('Select Full name')} />
          </Form.Item>
          <Form.Item
            label={translation('Path')}
            name="path"
            rules={[{ required: true, message: translation('Enter path') }]}
          >
            <Input placeholder={translation('Enter Path')} />
          </Form.Item>
        </Form>
        <DrawerFooter>
          <Button type="primary" onClick={onClose} style={{ marginRight: 8 }}>
            {translation('Cancel')}
          </Button>
          {editObj.Id ? (
            <Button onClick={updateMenu} type="primary">
              {translation('Update')}
            </Button>
          ) : (
            <Button onClick={saveMenu} type="primary">
              {translation('Save')}
            </Button>
          )}
        </DrawerFooter>
      </Drawer>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
    userProfile: state.LayoutReducer.loggedInProfile,
  };
};

export default connect(mapStateToProps)(MenuBuilder);